/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export default [
    {
        imageKey: 'send_a_gift.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt7829edd9ca31b717/6054b8562c06260f1e67556f/send_a_gift.svg',
    },
    {
        imageKey: 'support-listpicker.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltb7f501b31d533fc0/5fd12176d5cc794766340942/support-listpicker.jpg',
    },
    {
        imageKey: 'magnifying.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt7c76be5c00cfee70/6054b8565ec3360f1aab1335/magnifying.svg',
    },
    {
        imageKey: 'billing_discrepancy.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt61a030f2fa372c1c/6054b83e2c06260f1e67556b/billing_discrepancy.svg',
    },
    {
        imageKey: 'cancel-order.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt6b04f6d16dde0113/6054b83e23b7510ecf1ec316/cancel-order.svg',
    },
    {
        imageKey: 'calendar-icon.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt72937acf24567fbe/6054b83e8a6d130ee5e8267b/calendar-icon.svg',
    },
    {
        imageKey: 'customer-service.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt0bfc6908e55feede/6054b8565046ba0f2d727380/customer-service.svg',
    },
    {
        imageKey: 'billing_discrepancy.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt61a030f2fa372c1c/6054b83e2c06260f1e67556b/billing_discrepancy.svg',
    },
    {
        imageKey: 'status_check.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt0c7e744e1148ec58/6054b8560aa89f0eda274573/status_check-2.svg',
    },
    {
        imageKey: 'order-status.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blta07aca3d41de747b/6054b856791ed80f0b8c6092/order-status-2.svg',
    },
    {
        imageKey: 'Residence.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt46f6e028a957238b/5fdac2d0b08361084bff96b0/Residence.jpg',
    },
    {
        imageKey: 'Business.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt19e0c709384778f4/5fdac2dee7fdff751b7916d7/Business.jpg',
    },
    {
        imageKey: 'FuneralHome.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blta0036dd290912e14/5fdac2ceb529867fcec23e1c/FuneralHome.jpg',
    },
    {
        imageKey: 'Hospital.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt51f19c0b286b95d6/5fdac2d0396e65084a9e5248/Hospital.jpg',
    },
    {
        imageKey: 'Apartment.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltb881df162b56790a/5fdac2ce1166ce7d2ed18205/Apartment.jpg',
    },
    {
        imageKey: 'School.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt571467e935162cda/5fdac2d0a703d10ab87e7662/School.jpg',
    },
    {
        imageKey: 'Church.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt3b2c133e865e6e77/5fdac2ce02fd0c7d345f0ab7/Church.jpg',
    },
    {
        imageKey: 'get-well.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blte925aa0b5edd8b14/5fdac3926aab641cd100afe7/get-well.jpg',
    },
    {
        imageKey: 'housewarming.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltf960ef6bcfa36d11/5fdac392a7955d1a6a88f0e3/housewarming.jpg',
    },
    {
        imageKey: 'new-baby.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt51c7b4c0741c725f/5fdac386b80b0a1a68f9e6c4/new-baby.jpg',
    },
    {
        imageKey: 'love-romance.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltc9d0eaf3a8617b74/5fdac386b721aa1cd8dc083c/love-romance.jpg',
    },
    {
        imageKey: 'wildbeauty.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt788e9e6a66166fd9/5fdac3841688a075156a3690/wildbeauty.jpg',
    },
    {
        imageKey: 'just-because.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt0d60b22aa104c9d9/5fdac3841ebd9777b168dfb2/just-because.jpg',
    },
    {
        imageKey: 'birthday.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt028c49e6b81874f0/5fdac3828884c20ac3ca2c9f/birthday.jpg',
    },
    {
        imageKey: 'anniversary.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt4410f280f50e401d/5fdac382a703d10ab87e766a/anniversary.jpg',
    },
    {
        imageKey: 'im-sorry.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltbd2c8ea9a11830b0/5fdac38102fd0c7d345f0ac5/im-sorry.jpg',
    },
    {
        imageKey: 'congratulations.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltcea6572997511c72/5fdac3811166ce7d2ed18213/congratulations.jpg',
    },
    {
        imageKey: 'bestsellers.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt49811c5012b032d5/5fdac381b47cdf7fc7d687e7/bestsellers.jpg',
    },
    {
        imageKey: 'sympathy.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt208d656631f331a1/5fdac376a703d10ab87e7666/sympathy.jpg',
    },
    {
        imageKey: 'sameday.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltef806ebf327e64f9/5fdac3768884c20ac3ca2c9b/sameday.jpg',
    },
    {
        imageKey: 'thank-you.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt290f3ae9fb95c7f7/5fdac375b47cdf7fc7d687e3/thank-you.jpg',
    },
    {
        imageKey: 'retirement.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltce3b425006933e3b/5fdac3751166ce7d2ed1820f/retirement.jpg',
    },
    {
        imageKey: 'occasion-listpicker.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt722b02b774f6b7a9/5fdac375b47cdf7fc7d687df/occasion-listpicker.jpg',
    },
    {
        imageKey: 'btn-back.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt312b8db6422bef49/6054b83e5ec3360f1aab1331/btn-back-2.svg',
    },
    {
        imageKey: 'location.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt56478228dd80ce9e/6000d598da1b7963accb080e/location.jpg',
    },
    {
        imageKey: 'valentines.jpg',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt87b0c5e704036d43/600635c93c38be10329e1263/valentines.jpg',
    },
    {
        imageKey: 'modify-order.png',
        imageValue: 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltb306b67cf9fcd5cf/6079f9a0eea64578d07fc6e9/modify-order.png',
    },
];
